import { render } from "./EditPhone.vue?vue&type=template&id=11b145e1"
import script from "./EditPhone.vue?vue&type=script&lang=js"
export * from "./EditPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__